import { AdminsService } from '@/services/admins.service.js';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      alert: {
        show: false,
        message: ''
      },
      showDialog: false,
      selectedCampaign: null,
      campaigns: [{
        value: 'followup',
        text: 'Follow Up'
      }, {
        value: 'paymentfailed',
        text: 'Failed Payment'
      }],
      campaignDescription: {
        followup: 'This removes patient from the follow up email campaign. The patient will stop receiving email notifications about follow ups.',
        paymentfailed: 'This action removes the patient from the failed payment campaign. As a result, the patient will no longer receive email notifications about failed payments unless the system detects a new failed payment.'
      },
      buttonDisabled: false
    };
  },
  watch: {
    showDialog() {
      this.alert.show = false;
      this.selectedCampaign = null;
      this.buttonDisabled = false;
    }
  },
  methods: {
    async onRemoveFromCampaign() {
      if (!this.selectedCampaign) {
        this.alert.message = 'Please fill in all the fields.';
        this.alert.show = true;
        return;
      }
      try {
        this.buttonDisabled = true;
        const {
          data
        } = await AdminsService.removeFromCampaign(this.rowData.id, this.selectedCampaign);
        if (data) {
          this.showDialog = false;
        }
      } catch (err) {
        this.alert.message = err;
        this.alert.show = true;
      } finally {
        this.buttonDisabled = false;
      }
    }
  }
};